import { render, staticRenderFns } from "./PrintersList.vue?vue&type=template&id=04b11780&"
import script from "./PrintersList.vue?vue&type=script&lang=js&"
export * from "./PrintersList.vue?vue&type=script&lang=js&"
import style0 from "./PrintersList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports